import { LINCOLN_MONEYGUARD_2025_BANDS } from './lincolnPricingConfig';

export function getMultiplierForPremium(premium: number): number {
  const bands = LINCOLN_MONEYGUARD_2025_BANDS;

  if (premium <= bands[0].premium) return bands[0].multiplier;
  if (premium >= bands[bands.length - 1].premium) return bands[bands.length - 1].multiplier;

  for (let i = 0; i < bands.length - 1; i++) {
    if (premium >= bands[i].premium && premium < bands[i + 1].premium) {
      const t = (premium - bands[i].premium) / (bands[i + 1].premium - bands[i].premium);
      return bands[i].multiplier + t * (bands[i + 1].multiplier - bands[i].multiplier);
    }
  }

  return 1.0;
}
